const onBlur = async ({field, value, validator, errors}) => {
    let validate = validator.validateField(field, value);
    let aux = { ...errors }
    aux[field] = validate[field];
    return aux;
}

export default onBlur;